import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import { Dashboard, Home, Login, Perfil } from './Pages';
import { Header, Footer, ProtectedRoute } from './components';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/perfil" element={<Perfil />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;